import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getData } from './api';

export const {
	Context: TopicSupporterVoicesDataContext,
	Provider: TopicSupporterVoicesDataContextProvider,
	useContext: useTopicSupporterVoicesData,
	useAsyncData: useTopicSupporterVoicesDataFromApi,
	prefetchAsyncData: prefetchTopicSupporterVoicesDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'TopicSupporterVoicesDataContext',
	dataProperty: 'supporterVoicesData',
	getData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler(),
});
